module.exports = __webpack_public_path__ + "img/servicio_7.fd962f30.jpg";